module.exports = __webpack_public_path__ + "img/whitlam-small.caad7336.jpg";